<template>
    <div>
        <v-overlay :value="isLoading">
            <v-progress-circular indeterminate
                                 color="primary"
                                 :size="70"
                                 :width="7"></v-progress-circular>
        </v-overlay>
        <v-card>
            <v-alert width="100%" class="pr-2 pl-2" v-if="errorMessage" type="error"> {{ errorMessage }}</v-alert>
            
            <v-data-table dense class="elevation-1"
                          :headers="headers"
                          :items="luItems"
                          item-key="id"
                          :loading="isLoading"
                          :items-per-page="15">

                <template v-slot:[`item.id`]="{ item }">
                    {{ item.id}}

                </template>
                <template v-slot:[`item.description`]="{ item }">
                    {{ item.description}}

                </template>

                <template v-slot:top>
                    <v-toolbar flat>
                        <v-spacer></v-spacer>
                        <v-btn class="text-xs" v-on:click="refresh" color="primary">
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                        <v-dialog v-model="dialog"
                                  max-width="250px">

                            <v-card>
                                <v-card-title>
                                    {{editedItem.description}}
                                </v-card-title>

                                <v-card-text>
                                    <v-container>
                                        <table>
                                            <tr>
                                                <td>
                                                    <v-text-field v-model="editedItem.nextId" label="Next Id:" :disabled="editedIndex != -1" />
                                                </td>
                                                <td>
                                                    <v-btn icon v-on:click="(e) => incrementId(editedItem)" color="primary">
                                                        <v-icon>mdi-plus</v-icon>
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1"
                                           text
                                           @click="close">
                                        Cancel
                                    </v-btn>
                                    <v-btn color="blue darken-1"
                                           text
                                           @click="save">
                                        Save
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                    </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-icon small
                            class="mr-2"
                            @click="editItem(item)">
                        mdi-pencil
                    </v-icon>

                </template>

            </v-data-table>

        </v-card>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import lookupsService from "@/services/admin/lookupsService";
import { MemberTypeLookupInfo } from "@/types/admin/Lookup";

export default Vue.extend({
    name: "MemberTypeMaintenance",
    data: function () {
        return {
            tab: null,
            luItems: [] as MemberTypeLookupInfo[],
            tdialog: false,
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: "Description", align: "left", value: "description" },
                { text: "Next ID", align: "left", value: "nextId" },
                { text: "Actions", value: "actions", sortable: false },
            ],
            editedIndex: -1,
            editedItem: {
                description: "",
                nextId: 0,
                id: 0,

            },  
            isLoading: false,
            errorMessage: "",

        };
    },
    created: function () {
        this.refresh();
    },
    methods: {
        refresh: function () {
            this.$data.isLoading = true;
            this.errorMessage = "";
            lookupsService.getMemberTypeInfo().then((res: MemberTypeLookupInfo[]) => {
                this.luItems = res;
                this.$data.isLoading = false;
            });
        },
        editItem(item: MemberTypeLookupInfo) {
            this.errorMessage = "";
            this.editedIndex = this.luItems.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },
        incrementId(item: MemberTypeLookupInfo) {
            item.nextId++;

        },
        close() {
            this.dialog = false
            
        },
        save() {               
            this.errorMessage = "";
            lookupsService.editMemberType(this.editedItem).then((res: any) => {
                if (res.success) {
                    
                    Object.assign(this.luItems[this.editedIndex], this.editedItem)
                }
                else {
                    this.errorMessage = "Unable to increment id.";
                    
                }
            }).catch(
                () => {
                    this.errorMessage = "Unable to increment id.";
                });

            this.close();
            
        },
        
    }, 
    watch: {
        dialog(val) {
            val || this.close()
        },
        
    },
    
});
</script>
